import { createFailAction } from '../redux-util/async-helpers';
import * as m from './jigsaw-methods';
import { createReducer } from '../redux-util/general-helpers';
import { withDestroyViewerReset } from '../reset-reducer-helpers';

const actions = [
  m.UPDATE_HIGHLIGHT,
  m.HIGHLIGHT_CURRENT,
  m.DELETE_HIGHLIGHT,
  m.DELETE_BOOKMARK,
  m.GO_TO_PAGE,
  m.GO_TO_CFI,
  m.GO_TO_HIGHLIGHT,
  m.SET_BOOKMARK,
  m.SET_ZOOM_SCALE,
  m.INCREASE_ZOOM,
  m.DECREASE_ZOOM,
  m.GET_BOOKMARKS,
  m.GET_HIGHLIGHTS,
  m.GET_NOTES,
  m.GO_TO_BOOKMARK,
  m.UPDATE_NOTE,
  m.ADD_NOTE,
  m.DELETE_NOTE,
];

const collectionHandlers = {};
actions.forEach(a => {
  const key = createFailAction(a).type;
  collectionHandlers[key] = (state, action) => {
    return [
      ...state,
      {
        type: a,
        data: action.data,
      },
    ];
  };
});

export default withDestroyViewerReset(createReducer([], collectionHandlers));
